import { NgModule } from '@angular/core'
import { Routes, RouterModule, ExtraOptions } from '@angular/router'
import { LoginComponent } from './login/login.component'
import { HomeComponent } from './home/home.component'
import { GenerateCourseFormComponent } from './generate-course-form/generate-course-form.component'
import { MyCategoriesCoursesComponent } from './my-categories-courses/my-categories-courses.component'
import { CourseComponent } from './course/course.component'
import { RefactorTextComponent } from './refactor-text/refactor-text.component'
import { MergeSplitHeadingsComponent } from './merge-split-headings/merge-split-headings.component'
import { SuggestTitleComponent } from './suggest-title/suggest-title.component'
import { ExtractTextWebComponent } from './extract-text-web/extract-text-web.component'
import { GenerateActivitiesTestComponent } from './generate-activities-test/generate-activities-test.component'
import { GenerateGlossaryComponent } from './generate-glossary/generate-glossary.component'
import { RecommendMultimediaComponent } from './recommend-multimedia/recommend-multimedia.component'
// import { ExtractImagesComponent } from './extract-images/extract-images.component'
import { GenerateImagesComponent } from './generate-images/generate-images.component'
import { GenerateAudioComponent } from './generate-audio/generate-audio.component'
import { UsersComponent } from './users/users.component'
import { LogsComponent } from './logs/logs.component'
import { RepositoryComponent } from './repository/repository.component'
import { ContactComponent } from './contact/contact.component'
import { HelpComponent } from './help/help.component'
import { AuthguardGuard } from './authguard.guard'

const routerOptions: ExtraOptions = {
	onSameUrlNavigation: 'reload',
	anchorScrolling: 'enabled',
	// scrollPositionRestoration: 'enabled'
}

const routes: Routes = [
	{ path: 'login', component: LoginComponent },
	{ path: 'home', component: HomeComponent, canActivate: [AuthguardGuard] },
	{ path: 'generate-course', component: GenerateCourseFormComponent, canActivate: [AuthguardGuard] },
	{ path: 'generate-course/:course', component: GenerateCourseFormComponent, canActivate: [AuthguardGuard] },
	{ path: 'generate-course/:course/:category', component: GenerateCourseFormComponent, canActivate: [AuthguardGuard] },
	{ path: 'my-categories-courses', component: MyCategoriesCoursesComponent, canActivate: [AuthguardGuard] },
	{ path: 'course/:id', component: CourseComponent, canActivate: [AuthguardGuard] },
	{ path: 'refactor-text/:id', component: RefactorTextComponent, canActivate: [AuthguardGuard] },
	{ path: 'merge-split-headings/:id', component: MergeSplitHeadingsComponent, canActivate: [AuthguardGuard] },
	{ path: 'suggest-title/:id', component: SuggestTitleComponent, canActivate: [AuthguardGuard] },
	{ path: 'extract-text-web/:id', component: ExtractTextWebComponent, canActivate: [AuthguardGuard] },
	{ path: 'generate-activities-test/:id', component: GenerateActivitiesTestComponent, canActivate: [AuthguardGuard] },
	{ path: 'generate-glossary/:id', component: GenerateGlossaryComponent, canActivate: [AuthguardGuard] },
	{ path: 'recommend-multimedia/:id', component: RecommendMultimediaComponent, canActivate: [AuthguardGuard] },
	// { path: 'extract-images/:id', component: ExtractImagesComponent, canActivate: [AuthguardGuard] },
	{ path: 'generate-images/:id', component: GenerateImagesComponent, canActivate: [AuthguardGuard] },
	{ path: 'generate-audio/:id', component: GenerateAudioComponent, canActivate: [AuthguardGuard] },
	{ path: 'users', component: UsersComponent, canActivate: [AuthguardGuard] },
	{ path: 'logs', component: LogsComponent, canActivate: [AuthguardGuard] },
	{ path: 'repository', component: RepositoryComponent, canActivate: [AuthguardGuard] },
	{ path: 'contact', component: ContactComponent, canActivate: [AuthguardGuard] },
	{ path: 'help', component: HelpComponent, canActivate: [AuthguardGuard] },
	{ path: '', component: HomeComponent, canActivate: [AuthguardGuard] },
]

@NgModule({
	imports: [RouterModule.forRoot(routes, routerOptions)],
	exports: [RouterModule]
})

export class AppRoutingModule { }